var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcPin = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 21 29",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6501 10.15V2.9H18.1001C18.8976 2.9 19.5501 2.2475 19.5501 1.45C19.5501 0.6525 18.8976 0 18.1001 0H3.60007C2.80257 0 2.15007 0.6525 2.15007 1.45C2.15007 2.2475 2.80257 2.9 3.60007 2.9H5.05007V10.15C5.05007 12.557 3.10707 14.5 0.700073 14.5V17.4H9.35657V27.55L10.8066 29L12.2566 27.55V17.4H21.0001V14.5C18.5931 14.5 16.6501 12.557 16.6501 10.15Z",
    fill: "#2E63FB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pin.fb918c0b.svg";
export { ForwardRef as ReactComponent };